import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { trackEvent, trackException } from './appInsights';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export async function fetchAndParse<T>(url: string, headers?: {}): Promise<T> {
    try {
        const response = await fetch(url, headers);

        if (!response.ok) {
            trackEvent('fetchAndParse', { ...response });

            return Promise.reject(response);
        }

        const data = await response.json();

        return data as T;
    } catch (error: any) {
        trackException(error);

        return Promise.reject(error);
    }
}

export async function fetchFile(url: string, headers?: {}): Promise<Blob> {
    try {
        const response = await fetch(url, headers);
        if (!response.ok) {
            trackEvent('fetchFile', { ...response });

            return Promise.reject(response);
        }
        const data = await response.blob();
        return data;
    } catch (error: any) {
        trackException(error);
        return Promise.reject(error);
    }
}

export const getTotalPages = (amount: number, totalPages: number): number[] => {
    const total = Math.ceil(amount / totalPages);
    const pages = [];

    for (let i = 1; i <= total; i++) {
        pages.push(i);
    }

    return pages;
};

export const buildQueryKey = (key: string, param?: string): string => {
    return param ? `${key}-${param}` : key;
};
